export default __webpack_public_path__ + "static/media/GCP_logo.552169bd.svg";